'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { SectionHeaderAccentProps } from '../../../headers/section-header/section-header-accent.tsx'
import { SectionHeader } from '../../../headers/section-header/section-header.tsx'
import { useSectionHeaderContext } from '../../../headers/section-header/use-section-header.ts'

export type ModalHeaderAccentProps = SectionHeaderAccentProps

export const ModalHeaderAccent = ({
  className,
  fill = 'solid',
  ...props
}: ModalHeaderAccentProps) => {
  const { size } = useSectionHeaderContext()

  return (
    <SectionHeader.Accent
      {...props}
      fill={fill}
      className={cn(size === 'md' && 'h-12 w-12', className)}
    />
  )
}
